import styled from 'styled-components';
import { smallSpacedHeading, H2 } from '../../../../theme/typography';

export const CodeTitle = styled.h1`
  ${smallSpacedHeading};
`;

export const Code = styled(H2)``;
